module.exports = {"component":"icon","status":"prod","display-name":"Icons","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/icons","url-slug":"icons"}


//////////////////
// WEBPACK FOOTER
// ./components/icon/docs.json
// module id = 137
// module chunks = 0